import './vendor/modernizr';
import jQuery from 'jquery';
import { isSafari } from './helper';

window.$ = window.jQuery = jQuery;
window.$.ajaxSetup({
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
});

window.$(() => $.support.transition = false);
window.JS_SCROLL_BEHAVIOR = 'smooth';

import '@hotwired/turbo';

/*
 * Bootstrap modules + replacements
 */
// import 'vite/modulepreload-polyfill';
import './modal';
import tooltip from './tooltip';
import collapse from './collapse';

import toc from './vendor/toc';
import externalLinks from './external_links';
import header from './header';
import form from './form';
import navigation from './navigation';
import contentNavigation from './content_navigation';
import newsletter from './newsletter';
import content from './content';
import blog from './blog';
import scripts from './scripts';
import masonry from './masonry';
//import messageflow from './messageflow';
import typography from './typography';
import tables from './tables';
import pageSections2020 from './page-sections-2020';
import shop from './shop';
import toc2021 from './toc';
import scrollbarWidth from './scrollbar_width';
import styledTouchScrollbars from './styled_touch_scrollbars';
import turbolinksSetup from './turbolinks-setup';
import apps from './apps';
import calculator from './calculator';
import ajaxchimp from './ajaxchimp';
import articleTracker from './article_tracker';
import {markCurrentCenteredElementOnScroll, scrollToNextOrPreviousElement} from './centered-element-on-scroll';
import '@lottiefiles/lottie-player';
import {horizontalSlider} from '../../placetel-webex/js/components/HorizontalSlider';
import * as Sentry from '@sentry/browser';
// language selector
import Alpine from 'alpinejs';

function configureSentry(dsn) {
  let environment = document.location.host.match('www.placetel.') ? 'production' : 'staging';
  Sentry.init({
    allowUrls: [
      /staging\.placetel\.de/i,
      /www\.placetel\.de/i,
      /www\.placetel\.com/i,
    ],
    denyUrls:[
      /placetel\.de\/status/i,
      /status\.placetel\.de/i,
    ],
    dsn,
    environment,
    debug: environment !== 'production',
    ignoreErrors: [/^Warning: filemtime\(\)/, /^filemtime\(\)/, 'filemtime', 'Cannot read properties of undefined (reading \'parentNode\')']
  });
}

if (document.querySelector('meta[name="sentry-dsn"]')) {
  configureSentry(document.querySelector('meta[name="sentry-dsn"]').getAttribute('content'));
}

const initDocumentJavaScript = () => {
  /*
   * Reset sitesearch360 here, otherwise the search will not be initialized
   * `import siteSearch360 from './sitesearch360'` will be included where it's actually required
   */
  //window.ss360Config = null;

  window.horizontalSlider = horizontalSlider;

  Alpine.start();
  collapse();
  tooltip();
  navigation();
  scripts();
  externalLinks();
  turbolinksSetup();
  contentNavigation();
  header();
  form();
  content();
  typography();
  tables();
  toc();
  blog();
  toc2021();
  masonry();
  //messageflow();
  newsletter();
  pageSections2020();
  scrollbarWidth();
  styledTouchScrollbars();
  document
    .querySelectorAll('.mark-current-centered-element-on-scroll')
    .forEach(el => {
      markCurrentCenteredElementOnScroll(el, el.dataset.scrollableChildren, el.dataset.parentScrollableContainer)
      if (el.dataset.scrollNext && el.dataset.scrollPrevious) {
        scrollToNextOrPreviousElement(el, el.parentElement.querySelector(el.dataset.scrollNext), el.parentElement.querySelector(el.dataset.scrollPrevious))
      }
    });
  shop();
  apps();
  calculator();
  ajaxchimp();
  articleTracker();
};

const displayPlaceTelJobsInConsole = () => {
  console.group();
  console.log(
    '\n%c Hello %cPlace%ctel%c seekers 😎, \n\n the answer is %c42%c! \n\n Not what you are looking for? \n Then take a look at https://www.placetel.de/jobs\n\n',
    'background:rgba(0,0,0,0.05);color:inherit',
    'background:rgba(0,0,0,0.05);color:#1c9ee2;font-weight: bold;',
    'background:rgba(0,0,0,0.05);color:#6ab32d;font-weight: bold;',
    'background:rgba(0,0,0,0.05);color:inherit;font-weight: normal;',
    'background:rgba(0,0,0,0.05);color:#eb5f21;font-weight: bold;',
    'background:rgba(0,0,0,0.05);color:inherit;font-weight: normal;'
  );
  console.groupEnd();
};

if (window.Turbo) {
  document.addEventListener('turbo:load', initDocumentJavaScript);
} else {
  document.addEventListener('DOMContentLoaded', initDocumentJavaScript, false);
}

if (!document.location.href.startsWith('http://localhost')) {
  displayPlaceTelJobsInConsole();
}
